import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;

        return (
            <div>
                <h3><center><u>Advanced Request Status Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Created Date : </b> {searchData.fromDate}</div>
                    <div className="col"><b>Collection Point </b> {searchData.collectionPointID == 0 ? " : All" : searchData.collectionPointID}</div>
                    <div className="col"><b>Reg No </b> {searchData.regNo == "" ? " : All" : searchData.regNo}</div>
                    <div className="col"><b>Status </b> {searchData.status == 0 ? " : All" : searchData.status}</div>
                </div>


                <div>

                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" border="1px solid black">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Created Date
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Modified Date
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Collection Point
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Reg No
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Customer Name
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Requested Amount
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Approved Amount
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Employee Image
                                        </TableCell>
                                        <TableCell align="centre" style={{ fontWeight: "bold" }}>
                                            Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row) => (
                                        <TableRow key={row.employeeCode}>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.date}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.modifiedDate}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.collectionPointID}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.regNo}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.customerName}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.requestedAmount}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.approvedAmount}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.employeeImage == null ? " - " : row.employeeImage && (<img src={`data:employeeImage/jpeg;base64,${row.employeeImage}`} width="150" height="150"></img>)}
                                            </TableCell>
                                            <TableCell component="th" scope="row" align="centre">
                                                {row.status}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </div>
        );
    }
}


